// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__GZvhK","loader":"Loader_loader__lqUPL","spinner":"Loader_spinner__ShVmq"};